import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import fbImg from '../../assets/blog/Facebook.svg'
import linkImg from '../../assets/blog/Link.svg'
import pinterestImg from '../../assets/blog/Pinterest.svg'
import postPotImg from '../../assets/blog/pot.png'
import postSofaImg from '../../assets/blog/sofa.png'
import twitterImg from '../../assets/blog/x.svg'
import closeImg from '../../assets/close-white.svg'
import dmMobileWhiteImg from '../../assets/dm-mobile-white.svg'
import BlogFooter from '../../components/blog/Footer'
import BlogCategoriesList from '../../components/BlogCategoriesList'
import BlogCreateDesignBanner from '../../components/BlogCreateDesignBanner'
import BlogReadMore from '../../components/BlogReadMore'
import BlogStartYourDesignBanner from '../../components/BlogStartYourDesignBanner'
import BlogSubscribePopup from '../../components/BlogSubscribePopup'
import BlogTabs from '../../components/BlogTabs'
import ChallengeCard from '../../components/ChallengeCard'
import { InspirationItem } from '../../components/Feed'
import { useIsMobile } from '../../hooks/useIsMobile'
import { logEvent } from '../../utils/firebase'
import { formatDateToLocalizedString } from '../../utils/formatDate'
import {
  BlogContent,
  BlogPostBody,
  BlogPostCaption,
  BlogPostCategory,
  BlogPostContainer,
  BlogPostContent,
  BlogPostHeader,
  BlogPostInfo,
  BlogPostInfoMobile,
  BlogPostInfoShare,
  BlogPostParagraph,
  BlogPostShareButton,
  BlogPostSidebar,
  BlogPostSubtitle,
  BlogView,
  CodeBlock,
  FloatingPanel,
  FloatingPanelButton,
  FloatingPanelCloseButton,
  HeaderWrapper,
  ImageCtaButton,
  ImageWithButtonContainer,
  ListBlock,
  PostAdSeparator,
  PostImagePot,
  PostImageSofa,
  PostSeparatorButton,
  PostShadow,
  SignleDesignBlogTitle,
  SingleDesignBlock,
  SinglePostButton
} from './BlogPost.styles'

const SharePost = () => {
  return (
    <BlogPostInfoShare>
      <BlogPostShareButton
        onClick={() => {
          if (typeof window !== 'undefined') window.open(`https://pinterest.com/pin/create/button/?url=${window.location.href}`)
        }}
      >
        <img src={pinterestImg} alt="Pinterest" />
      </BlogPostShareButton>
      <BlogPostShareButton
        onClick={() => {
          if (typeof window !== 'undefined') window.open(`https://x.com/intent/tweet?url=${window.location.href}`)
        }}
      >
        <img src={twitterImg} alt="X (ex. Twitter)" />
      </BlogPostShareButton>
      <BlogPostShareButton
        onClick={() => {
          if (typeof window !== 'undefined') window.open(`http://www.facebook.com/share.php?u=${window.location.href}`)
        }}
      >
        <img src={fbImg} alt="Facebook" />
      </BlogPostShareButton>
      <BlogPostShareButton
        onClick={() => {
          if (typeof window !== 'undefined')
            navigator.clipboard
              .writeText(window.location.href)
              .then(() => {
                alert('Copied to clipboard')
              })
              .catch(() => {
                alert('Failed to copy. Please, try again.')
              })
        }}
      >
        <img src={linkImg} alt="Copy Link" />
      </BlogPostShareButton>
    </BlogPostInfoShare>
  )
}

export const BlogPost = ({ post, categories, readMorePosts, inspiration, challenge, featureLine }) => {
  const router = useRouter()
  const isMobile = useIsMobile()
  const content = post.attributes
  const body = JSON.parse(content.body)
  const [showCloseButton, setShowCloseButton] = useState(false)
  const [showFloatingPanel, setShowFloatingPanel] = useState(true)

  const postDate = new Date(post.attributes.updatedAt || post.attributes.publishedAt || post.attributes.createdAt)
  const imageAltCutoffDate = new Date('2025-12-17')

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCloseButton(true)
    }, 10000) // 10 seconds

    return () => clearTimeout(timer)
  }, [])

  const handleCloseFloatingPanel = () => {
    setShowFloatingPanel(false)
  }

  const sidePosts = (
    <>
      <div>
        <SingleDesignBlock>
          <SignleDesignBlogTitle>Challenges Happening Now</SignleDesignBlogTitle>
          <ChallengeCard
            onClickMore={() => {
              logEvent('challenges_happening_now_click', {})
              router.push('/')
            }}
            onClickJoin={() => {
              logEvent('challenges_happening_now_click', {})
              router.push('/')
            }}
            data={challenge}
          />
          <SinglePostButton onClick={() => logEvent('challenges_happening_now_click', {})} href="http://decormatters.app.link/blog">
            View All
          </SinglePostButton>
        </SingleDesignBlock>
      </div>
      <div>
        <SingleDesignBlock>
          <SignleDesignBlogTitle>Trending User Designs</SignleDesignBlogTitle>
          <PostShadow>
            <InspirationItem sourcePost={inspiration} user={inspiration.user} likes={inspiration.numLikes} />
          </PostShadow>
          <SinglePostButton onClick={() => logEvent('trending_user_designs_click', {})} href="/interior-design-ideas" target="_blank">
            Explore More
          </SinglePostButton>
        </SingleDesignBlock>
      </div>
    </>
  )

  return (
    <>
      <BlogView>
        <HeaderWrapper>
          <BlogTabs hideTitle categories={categories.data} active={post?.attributes?.categories?.data && post?.attributes?.categories?.data[0] ? post.attributes.categories.data[0].id : null} />
          {/* {featureLine && (
            <FeatureLine
              bgColor={featureLine?.featureBgColor}
              textColor={featureLine?.featureTextColor}
              href={featureLine?.featureLink}
              onClick={() => {
                logEvent('blog_top_banner_click', {})
              }}
            >
              {featureLine?.featureTitle}
            </FeatureLine>
          )} */}
        </HeaderWrapper>
        <BlogContent>
          <BlogPostHeader>
            <Link href={`/blog/category/${content?.categories?.data[0]?.attributes.slug}`}>
              <BlogPostCategory>{content?.categories?.data[0]?.attributes.title}</BlogPostCategory>
            </Link>
            <h1>{content.title}</h1>
            {content.subtitle && <BlogPostSubtitle>{content.subtitle}</BlogPostSubtitle>}
            <BlogPostInfo>
              <BlogPostInfoMobile>
                {/* <img src={content.author.data.attributes.image.data.attributes.formats.thumbnail.url} alt="" /> */}
                <span>by {content.author.data.attributes.name}</span>
                <span>|</span>
                <span>{content.updatedDatetime ? `updated ${formatDateToLocalizedString(new Date(content.updatedDatetime))}` : formatDateToLocalizedString(new Date(content.createdDatetime || content.publishedAt))}</span>
              </BlogPostInfoMobile>
              {!isMobile && <SharePost />}
            </BlogPostInfo>
            {isMobile && <SharePost />}
          </BlogPostHeader>
          <BlogPostContainer>
            <BlogPostContent>
              <BlogPostBody>
                {body.blocks.map(block => {
                  switch (block.type) {
                    case 'paragraph':
                      return (
                        <BlogPostParagraph
                          alignment={block.data.alignment}
                          key={block.id}
                          dangerouslySetInnerHTML={{
                            __html: block.data.text
                          }}
                        />
                      )
                    case 'header':
                      const Element = `h${block.data.level}`

                      return <Element dangerouslySetInnerHTML={{ __html: block.data.text }} />
                    case 'image':
                      const isAfterCutoffDate = postDate.getTime() > imageAltCutoffDate.getTime()

                      if (isAfterCutoffDate) {
                        return (
                          <ImageWithButtonContainer key={block.id}>
                            <img key={block.id} src={block.data.file.url} alt={block.data.file.alternativeText || block.data.file.alt || 'Blog Post Image'} />
                            {block.data.caption && <BlogPostCaption>{block.data.caption}</BlogPostCaption>}
                            {block.data.show_create_button && <ImageCtaButton href="/">Try Your Own Design</ImageCtaButton>}
                          </ImageWithButtonContainer>
                        )
                      }

                      return (
                        <ImageWithButtonContainer key={block.id}>
                          <img key={block.id} src={block.data.file.url} alt={block.data.caption || 'Blog Post Image'} />
                          {block.data.show_create_button && <ImageCtaButton href="/">Try Your Own Design</ImageCtaButton>}
                        </ImageWithButtonContainer>
                      )
                    case 'code':
                      return <CodeBlock key={block.id} dangerouslySetInnerHTML={{ __html: block.data.code }} />
                    case 'list':
                      return (
                        <ListBlock>
                          {block?.data?.items.map((d, i) => (
                            <li dangerouslySetInnerHTML={{ __html: d }} />
                          ))}
                        </ListBlock>
                      )

                    /*
                        return (
                          <ListBlock
                            key={block.id}
                            dangerouslySetInnerHTML={{ __html: block.data.code }}
                          />
                        )
                        */
                    case 'adSeparator':
                      return (
                        <PostAdSeparator>
                          <PostImageSofa src={postSofaImg} alt="" />
                          <PostImagePot src={postPotImg} alt="" />
                          <span>Want to visualize real furniture in your room?</span>
                          <PostSeparatorButton href="https://decormatters.app.link/HZ1MfpegHQb">Design Now</PostSeparatorButton>
                        </PostAdSeparator>
                      )
                    default:
                      return null
                  }
                })}
              </BlogPostBody>
              {isMobile && <SharePost />}
            </BlogPostContent>
            {!isMobile && (
              <BlogPostSidebar>
                <div>
                  <BlogStartYourDesignBanner />
                  <BlogCategoriesList categories={categories.data} />
                  {sidePosts}
                </div>
              </BlogPostSidebar>
            )}
          </BlogPostContainer>
          <BlogCreateDesignBanner />
          <BlogReadMore posts={readMorePosts} />
        </BlogContent>
        <BlogFooter />
      </BlogView>
      <BlogSubscribePopup />
      {showFloatingPanel && (
        <FloatingPanel>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img src={dmMobileWhiteImg} alt="DecorMatters" />
            <div>
              <span style={{ fontSize: '14px', fontWeight: 'bold', display: 'block' }}>Inspired by these ideas?</span>
              <span style={{ fontSize: '12px' }}>Use our AI room design app</span>
            </div>
          </div>
          <FloatingPanelButton href="https://decormatters.app.link/80ncCwu73Tb">Get the app</FloatingPanelButton>
          {showCloseButton && (
            <FloatingPanelCloseButton onClick={handleCloseFloatingPanel}>
              <img src={closeImg} alt="Close" width={10} height={10} />
            </FloatingPanelCloseButton>
          )}
        </FloatingPanel>
      )}
    </>
  )
}
